import { ClientItem } from 'owa-mail-store';

export default function getFirstBody(item: ClientItem, isConversationItemPart: boolean): string {
    if (isConversationItemPart) {
        return item.UniqueBody.Value;
    } else {
        return item.NormalizedBody.Value;
    }
}
